<template>
<svg width="213" height="79" viewBox="0 0 213 103" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M124.668 255.102C107.633 291.637 91.9719 302.712 20.7422 300.298C-4.39706 295.267 -40.5029 207.789 -71.7554 159.244C-95.8914 121.75 -120.68 74.7901 -89.873 33.5235C-55.2155 -12.9197 26.335 -9.62795 55.1573 39.4325C75.8219 74.6204 86.7654 79.6425 130.863 74.1752C179.856 68.1007 201.491 78.1052 210.238 110.882C217.154 136.77 205.036 160.411 186.126 177.354C143.224 215.797 142.66 216.507 124.668 255.102Z" fill="#FF5C00"/>
</svg>
</template>
<script lang="ts" setup>

</script>
